/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, FormGroup, FormControl, Form } from 'react-bootstrap';
import Select from '../../../../modules/react/components/stateful/Select';
import Icon from '../../../../modules/react/components/stateless/Icon';
import styles from './StockIcons.scss';

export default class IconStyleTab extends React.Component {
  static propTypes = {
    colors: PropTypes.shape({
      primary: PropTypes.string.isRequired,
      secondary: PropTypes.string.isRequired,
      tertiary: PropTypes.string.isRequired,
    }).isRequired,
    color: PropTypes.string.isRequired,
    setTarget: PropTypes.func.isRequired,
    handleColorChange: PropTypes.func.isRequired,
    handleHrefChange: PropTypes.func.isRequired,
    handleAlignChange: PropTypes.func.isRequired,
    showColorField: PropTypes.bool.isRequired,
    icon: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    align: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
  };

  renderColor(marginTop) {
    const { colors: { primary, secondary, tertiary } } = this.props;
    return (option) => {
      const { value, label } = option;
      if (value === primary || value === secondary || value === tertiary) {
        return (
          <span>
            <div
              style={{ backgroundColor: value, marginTop }}
              className={styles.colorBlock}
            />
            {label}
          </span>
        );
      }
      return <span style={{ marginLeft: '15px' }}>{label}</span>;
    };
  }

  static renderAlignment() {
    return (option) => {
      if (!option) {
        return '';
      }

      const { label } = option;

      return (
        <span>
          {label}
        </span>
      );
    };
  }

  render() {
    const {
      colors: { primary, secondary, tertiary },
      icon, align, color, showColorField, handleColorChange,
      handleHrefChange, handleAlignChange, href, setTarget, target,
    } = this.props;

    const colorOptions = [
      { value: primary, label: 'primary' },
      { value: secondary, label: 'secondary' },
      { value: tertiary, label: 'tertiary' },
      { value: 'custom', label: 'custom' },
    ];
    const alignOptions = [
      { value: 'text-start', label: 'left' },
      { value: 'text-center', label: 'center' },
      { value: 'text-end', label: 'right' },
    ];
    return (
      <div>
        <Row>
          <div className={styles.stylingTitle}>Customize how your icon appears.</div>
          <Col xs={4} className={styles.iconStyle}>
            <div>
              <span
                className={`${icon} ${styles.iconPreview}`}
                style={{ color: color || secondary }}
              />
            </div>
          </Col>
        </Row>
        <Row className={styles.iconStylesRow}>
          <Col xs={6} className={styles.colorLeftAlign}>
            <div className={styles.optionsText}>Color</div>
            <Col xs={6}>
              <Select
                autoBlur
                className={styles.selectColorOptions}
                clearable={false}
                instanceId="color-selector"
                onChange={handleColorChange}
                optionRenderer={this.renderColor('3px')}
                valueRenderer={this.renderColor('10px')}
                options={colorOptions}
                value={color === primary || color === secondary || color === tertiary ? color : 'custom'}
                searchable={false}
              />
            </Col>
            {
              showColorField ? (
                <Col xs={6} className={styles.colorField}>
                  <Col xs={1} className={styles.hash}>#</Col>
                  <Col xs={2}>
                    <input
                      value={color.substr(1)}
                      name="color"
                      className={styles.hexInputField}
                      onChange={e => handleColorChange({ value: `#${e.target.value}` })}
                    />
                  </Col>
                </Col>
              ) : null
            }
          </Col>
          <Col xs={6} className={styles.moveRight}>
            <div className={styles.optionsText}>Alignment</div>
            <Col xs={3}>
              <Select
                autoBlur
                className={styles.selectColorOptions}
                clearable={false}
                instanceId="color-selector"
                onChange={handleAlignChange}
                optionRenderer={IconStyleTab.renderAlignment()}
                valueRenderer={IconStyleTab.renderAlignment()}
                options={alignOptions}
                value={align}
                searchable={false}
              />
            </Col>
          </Col>
        </Row>
        <Row className={styles.insertLinkContainer}>
          <Col xs={7}>
            <FormGroup as={Row}>
              <Col xs={2} className={styles.ref}>
                <Icon id="linkout2" className={styles.linkIcon} label="Link" />
              </Col>
              <Col xs={10}>
                <FormControl
                  className={styles.linkText}
                  placeholder="Insert link here"
                  onChange={e => handleHrefChange({ value: e.target.value })}
                  value={href}
                />
              </Col>
            </FormGroup>
          </Col>
        </Row>
        <FormGroup className={styles.linkOptionLeftPadding}>
          <Row>
            <Col xs={4} className={styles.descriptionSeparation}>
              <Row>
                <Col xs={12}>
                  <Form.Check
                    id="target-self-same-tab"
                    type="radio"
                    name="targetTrigger"
                    checked={target === '_self'}
                    value="_self"
                    onChange={setTarget}
                    label="Open link in same tab"
                    className={styles.radioOption}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <Form.Check
                    id="target-self-new-tab"
                    type="radio"
                    name="targetTrigger"
                    checked={target === '_blank'}
                    value="_blank"
                    onChange={setTarget}
                    label="Open link in new tab"
                    className={styles.radioOption}
                  />
                </Col>
              </Row>
            </Col>
            <Col xs={8} className={`text-muted ${styles.descriptiveRowStyle}`}>
              <div>
                If you want to link to a page on your website enter:
              </div>
              <div>
                '/url-of-your-page'
              </div>
              <div className={styles.descriptionSeparation}>
                If you want to link to another website enter:
              </div>
              <div>
                'http://www.domain.com' or 'https://www.domain.com'
              </div>
            </Col>
          </Row>
        </FormGroup>
      </div>
    );
  }
}
